<div class="stripe-form stripe-form-modal">
  <div class="header-modal mb-0">
    <div class="main-title w-100 mt-0 mb-0">
      <h3>New Payment</h3>
    </div>

    <span class="close-dialog" mat-dialog-close>
      <i class="material-icons">close</i>
    </span>
  </div>

  <!-- Stripe Form -->
  <form (ngSubmit)="onSubmit()" [formGroup]="stripeForm">
    <div class="form-add-new-wrap">
      <div class="form-add-new-content">
        <!-- Full Name -->
        <div class="form-group">
          <label>Card Holder Name <span class="required-symbol">*</span></label>
          <input autocomplete="off" class="form-control" formControlName="name" placeholder="Card Holder Name"
                 type="text" style="text-transform:uppercase">
          <span *ngIf="tooltipService.getState('name')">
              <app-tooltip
                [errorMessages]="tooltipService.inputValidation('name', defaultRequired, defaultExists, defaultInvalid)"
                [position]="'below'"
                [fieldName]="'Card Holder Name'">
              </app-tooltip>
            </span>
        </div>

        <!-- Card Number -->
        <!--          <div class="form-group">-->
        <!--            <label>Card Number <span class="required-symbol">*</span></label>-->
        <!--            <div class="field" id="card-number"></div>-->
        <!--          </div>-->
      </div>

      <div class="form-group">
        <ngx-stripe-card
          [options]="cardOptions"
          [elementsOptions]="elementsOptions"
        ></ngx-stripe-card>
      </div>

      <div class="row card-buttons">
        <!--    todo: after release implement it
          <div class="col-xl-10">
              <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="confirm" (click)="onCheckBoxClicked()">
                  <label class="form-check-label" for="confirm">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  </label>
              </div>
          </div>
          -->
        <div class="footer-modal">
          <cmp-button [class]="'cancel mr-20'" text="Cancel" (click)="cancel()"></cmp-button>
          <cmp-button [disabled]='confirmBtnDisabled' type="submit" [class]="'primary mr-20'" text="Save Card"
                      [loading]="saveBtnLoading"></cmp-button>
        </div>
      </div>
    </div>
  </form>
</div>
